"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var loader_1 = require("../loader");
var getCSSStyle = function (column, row) { return ({
    flexDirection: column ? "column" : "row"
}); };
var getMessageCSSStyle = function (width, column, row) {
    var _a;
    return (_a = {},
        _a[column ? "marginTop" : "marginLeft"] = utils_1.toREMString(width / 3),
        _a.fontSize = utils_1.toREMString(width / 2),
        _a);
};
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, blue = _a.blue, gray = _a.gray, column = _a.column, row = _a.row, _b = _a.message, message = _b === void 0 ? "Loading..." : _b, _c = _a.size, size = _c === void 0 ? 4 : _c, others = tslib_1.__rest(_a, ["theme", "className", "blue", "gray", "column", "row", "message", "size"]);
    return (React.createElement("div", tslib_1.__assign({}, others, { style: getCSSStyle(column, row), className: classnames_1.default(theme["page-loader"], className) }),
        React.createElement(loader_1.CircleLoader, { size: size, blue: blue, gray: gray }),
        message ? React.createElement("div", { className: theme.message, style: getMessageCSSStyle(size, column, row) }, message) : null));
});
